import kitchenInstance from '../instance'

const createWaiterNotification = (data) => {
	return kitchenInstance.post('/waiterNotifications', data)
}

export default createWaiterNotification
